import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	activeExam: null,
	data: null,
	error: null,
	loading: false,
	openModal: false,
	openResultModal: false,
	generateFilters: null,
	streakUpdated: false
};

const setOpenExamModal = (state, action) => updateObject(state, { openModal: action.openModal });

const setOpenResultModal = (state, action) =>
	updateObject(state, {
		openResultModal: action.openResultModal
	});

const setStreakUpdated = (state, action) =>
	updateObject(state, {
		streakUpdated: action.streakUpdated
	});

const clearGenerateFilters = (state) =>
	updateObject(state, {
		generateFilters: null
	});

const clearExamState = (state) =>
	updateObject(state, initialState);

const setExamQuestionNumber = (state, action) =>
	updateObject(state, {
		questionNumber: action.questionNumber
	});

const setExamData = (state, action) =>
	updateObject(state, {
		data: action.data,
		error: null,
	});

const setGenerateFilters = (state, action) =>
	updateObject(state, {
		generateFilters: action.data,
		error: null,
	});

const fetchExamStart = (state, action) => updateObject(state, { loading: true });

const setActiveExam = (state, action) => {
	return updateObject(state, {
		activeExam: action.data
	});
};

const fetchExamSuccess = (state, action) => {
	return updateObject(state, {
		loading: false
	});
};

const fetchExamsSuccess = (state, action) => {
	return updateObject(state, {
		data: action.data.Exams,
		loading: false
	});
};

const fetchExamFail = (state, action) =>
	updateObject(state, { error: action.error, loading: false });

const fetchExamLogsSuccess = (state, action) =>
	updateObject(state, {
		data: action.data,
		loading: false
	});

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SET_ACTIVE_EXAM:
			return setActiveExam(state, action);
		case actionTypes.SET_EXAM_QUESTIONS:
			return setExamQuestions(state, action);
		case actionTypes.SET_OPEN_EXAM_MODAL:
			return setOpenExamModal(state, action);
		case actionTypes.SET_OPEN_RESULT_MODAL:
			return setOpenResultModal(state, action);
		case actionTypes.SET_QUESTION_EXAM_NUMBER:
			return setExamQuestionNumber(state, action);
		case actionTypes.SET_EXAM_DATA:
			return setExamData(state, action);
		case actionTypes.FETCH_EXAM_START:
			return fetchExamStart(state, action);
		case actionTypes.FETCH_EXAM_SUCCESS:
			return fetchExamSuccess(state, action);
		case actionTypes.FETCH_EXAM_FAIL:
			return fetchExamFail(state, action);
		case actionTypes.FETCH_EXAMS_SUCCESS:
			return fetchExamsSuccess(state, action);
		case actionTypes.CLEAR_EXAM_STATE:
			return clearExamState(state, action);
		case actionTypes.CLEAR_GENERATE_FILTERS:
			return clearGenerateFilters(state);
		case actionTypes.SET_STREAK_UPDATED:
			return setStreakUpdated(state, action);
		case actionTypes.SET_START_TIME:
			return setStartTime(state, action);
		case actionTypes.FETCH_EXAM_LOGS_SUCCESS:
			return fetchExamLogsSuccess(state, action);
		case actionTypes.SET_GENERATE_FILTERS:
			return setGenerateFilters(state, action);
		default:
			return state;
	}
};

export default reducer;
